import { useState } from 'react'

import { Volume } from '@/api/type-server'

const DEFAULT_MOUNT_PATH = '/datadrive'

export function useMountConfig() {
  const [mountVolume, setMountVolume] = useState<Volume | undefined>()
  const [mountPath, setMountPath] = useState<string>(DEFAULT_MOUNT_PATH)
  const [readWriteMode, setReadWriteMode] = useState<boolean>(false)

  const updateMountConfig = (
    volume?: Volume,
    path: string = DEFAULT_MOUNT_PATH,
    mode: boolean = false,
  ) => {
    setMountVolume(volume)
    setMountPath(path)
    setReadWriteMode(mode)
  }

  const resetMountConfig = () => {
    setMountVolume(undefined)
    setMountPath(DEFAULT_MOUNT_PATH)
    setReadWriteMode(false)
  }

  return {
    mountVolume,
    setMountVolume,
    mountPath,
    setMountPath,
    readWriteMode,
    setReadWriteMode,
    updateMountConfig,
    resetMountConfig,
  }
}
